import { Loader } from '@googlemaps/js-api-loader';
import { decode } from './queryEncryption';

export const googleMapLoader = async (googleMapBrowserApiKey, name) => {
    const loader = new Loader({
        apiKey: decode(googleMapBrowserApiKey),
        libraries: [name],
    });
    try {
        await loader.importLibrary(name);
    } catch (error) {
        console.error(error);
    }
}